import React from "react";

const WindyMapView = (props) => {

    return (
        <div>
            <iframe
                src={`
                    ${process.env.REACT_APP_WINDY_URL}${props.lat}&lon=${props.long}&detailLat=${props.lat}&detailLon=${props.long}&detail=true&pressure=true&message=true
                    `}
                width="100%"
                height="500"
                frameborder="0">
            </iframe>
        </div>
    );
};

export default WindyMapView;
